<template>
    <gofix-card fullContent>
        <gofix-default-table
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @get-selected="massUpdateModal"
                @export="exportCSV"
                ref="gofixTable">
            <template slot="gofix_table:lettable" slot-scope="row">
                {{row.item.lettable ? "Yes" : "No" }}
            </template>
            <template slot="gofix_table:root_path" slot-scope="row">
                {{ convertRootPath(row.item)}}
            </template>
            <template slot="gofix_table:mininum_rent" slot-scope="row">
                {{ row.item.mininum_rent | formatMoney}}
            </template>
            <template slot="gofix_table:minimum_rate_psf" slot-scope="row">
                {{ row.item.minimum_rate_psf | formatMoney}}
            </template>
            <template slot="gofix_table:reference_rent" slot-scope="row">
                {{ row.item.reference_rent | formatMoney}}
            </template>
            <template slot="gofix_table:reference_rate_psf" slot-scope="row">
                {{ row.item.reference_rate_psf | formatMoney}}
            </template>
            <template slot="gofix_table:gfa" slot-scope="row">
                {{ row.item.gfa | formatMoney(0,'')}}
            </template>
            <template slot="gofix_table:nla" slot-scope="row">
                {{ row.item.nla | formatMoney(0,'')}}
            </template>
            <template slot="gofix_table:effective_date" slot-scope="row">
                {{ row.item.effective_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
            </template>
            <template slot="gofix_table:property_type_name" slot-scope="row">
                {{ row.item.property_type_text}}
            </template>
            <template slot="gofix_table:location_type_name" slot-scope="row">
                {{ row.item.location_type_text }}
            </template>
        </gofix-default-table>

        <b-modal :no-close-on-backdrop="true" id="modal-mass-update" title="Edit Property" hide-footer :centered="true" modal-class="modal-create" ref="modal-mass-update" v-model="open">
            <p>Note: Select the field(s) you wish to update</p>
            <b-form class="pb-20 formV2">
                <b-row>
                    <b-col md="1">
                        <div class="custom-control custom-checkbox massupdate-checkbox">
                            <input type="checkbox" v-model="massUpdate.checkLocationType" class="custom-control-input" id="massUpdateChk1">
                            <label class="custom-control-label" for="massUpdateChk1"></label>
                        </div>
                    </b-col>
                    <b-col md="5">
                        <gofix-form-dropdown
                                label="Location Type"
                                vLabel="reference_value_text"
                                v-model="massUpdate.location_type"
                                :options="reference.location_type_name">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="1">
                        <div class="custom-control custom-checkbox massupdate-checkbox">
                            <input type="checkbox" class="custom-control-input" id="massUpdateChk2" v-model="massUpdate.checkPropertyType" >
                            <label class="custom-control-label" for="massUpdateChk2"></label>
                        </div>
                    </b-col>
                    <b-col md="5">
                        <gofix-form-dropdown
                                label="Property Type"
                                vLabel="reference_value_text"
                                v-model="massUpdate.property_type"
                                :options="reference.property_type_name">
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="1">
                        <div class="custom-control custom-checkbox massupdate-checkbox">
                            <input type="checkbox" class="custom-control-input" id="massUpdateChk3" v-model="massUpdate.checkLettable" >
                            <label class="custom-control-label" for="massUpdateChk3"></label>
                        </div>
                    </b-col>
                    <b-col md="5">
                        <gofix-form-dropdown
                                label="Lettable"
                                vLabel="text"
                                :reduce="option => option.value"
                                v-model="massUpdate.lettable"
                                :options="[{value: true, text: 'Yes'},{value: false, text: 'No'}]"
                        >
                        </gofix-form-dropdown>
                    </b-col>
                    <b-col md="1">
                        <div class="custom-control custom-checkbox massupdate-checkbox">
                            <input type="checkbox" class="custom-control-input" id="massUpdateChk4" v-model="massUpdate.checkCategory">
                            <label class="custom-control-label" for="massUpdateChk4"></label>
                        </div>
                    </b-col>
                    <b-col md="5">
                        <gofix-form-dropdown
                                label="Category"
                                vLabel="reference_value_text"
                                v-model="massUpdate.property_category"
                                :options="reference.category_name">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="CANCEL" @click="open = false" noBorder dark></gofix-button>
                <gofix-button label="OK" @click="submitMassUpdate" :loading="loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
      <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
        <b-progress :max="100" height="3rem" show-progress animated>
          <b-progress-bar :value="100">
            <span class="font-size-16">{{modals.export.process}}</span>
          </b-progress-bar>
        </b-progress>
      </b-modal>
    </gofix-card>
</template>
<script>
import { filters } from '@/_filterVar.js'

let filter =  JSON.parse(JSON.stringify(filters['property_general_info']));
let dataSelect = {
    lettable: {
        value: [
            {value: true, text: 'Yes'},
            {value: false, text: 'No'},
        ],
        value_field: 'value',
        text_field: 'text'
    },
    category_name: {
        value: [],
        value_field: 'reference_value_text',
        text_field: 'reference_value_text'
    },
    location_type_name: {
        value: [],
        value_field: 'reference_value_text',
        text_field: 'reference_value_text'
    },
    property_type_name: {
        value: [],
        value_field: 'reference_value_text',
        text_field: 'reference_value_text'
    }
}

export default {
    name: 'property-list',
    components: {},
    props:{
        propertyId: {
            type: Number,
            required: false,
            default: null
        },
        reference: {
            type: Object,
            required: true,
            default: {
                category_name:      [],
                location_type_name: [],
                property_type_name: []
            }
        },
    },
    data () {
        return {
            tableConfig:{
                dataSelect: dataSelect,
                name: 'client-contract-property-location',
                leftWidth: 1,
                rightWidth: 11,
                controls:{
                    create: false,
                    delete: false,
                    sendSelected:true,
                    sendSelectedText: "Update",
                    tableImport: false,
                    allItems: true,
                    sendSelectedHidden: true,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                useDatabaseView: true,
                sortColumn: "root_path",
                sortDirection: "asc",
            },
            tableItems:[],
            massUpdate: {
                location_type: null,
                property_type: null,
                property_category: null,
                lettable: true,
                checkPropertyType: true,
                checkLocationType: true,
                checkLettable: true,
                checkCategory: true,
            },
            open: false,
            loading: false,
            first_load: true,
          modals:{
            export:{
              open:false,
              loading:false,
              process:'Creating file csv',
              title: 'Export Data'
            }
          },
        }
    },
    watch: {
        "reference.category_name": function(val) {
            this.updateDataSelect('category_name', val);
        },
        "reference.location_type_name": function(val) {
            this.updateDataSelect('location_type_name', val);
        },
        "reference.property_type_name": function(val) {
            this.updateDataSelect('property_type_name', val);
        },
        propertyId: function(val) {
            if(val)
                this.$refs.gofixTable.reloadTableKeepFilter();
        }
    },
    created(){},
    methods:{
        updateDataSelect(key, data) {
            this.tableConfig.dataSelect[key].value = data;
            this.$refs['gofixTable'].updateDataSelect();
        },
        convertRootPath(row){
            let path = row.root_path;
            if(path == ''){
                return ''
            }else{
                let arr = path.split(" >> ");
                arr.pop();
                arr.shift();
                return arr.join(" >> ");
            }
        },
        massUpdateModal(){
            if(this.$refs.gofixTable.tableSelected.selected.length == 0){
                return this.$alertNotification("Please select at least one item", "danger");
            }
            this.open = true;
        },
        submitMassUpdate() {
            if(this.loading) return;
            if(!this.massUpdate.checkPropertyType && !this.massUpdate.checkLocationType && !this.massUpdate.checkCategory && !this.massUpdate.checkLettable) {
                return this.$alertNotification("Please select at least one checkbox to update.", "danger");
            }

            this.loading = true;

            let filter = null;
            if(this.$refs.gofixTable.tableSelected.allItems === true){
                filter = Object.assign(this.$refs.gofixTable.tableRequest.filter, { property_id: this.propertyId })
            }

            let request = {
                contract_id: this.$route.params.id,
                ids: this.$refs.gofixTable.tableSelected.selected,
                property_type_id: this.massUpdate.property_type && this.massUpdate.property_type.id,
                location_type_id: this.massUpdate.location_type && this.massUpdate.location_type.id,
                category_id: this.massUpdate.property_category && this.massUpdate.property_category.id,
                lettable: !this.massUpdate.lettable ? false : this.massUpdate.lettable,
                filter: filter
            }
            if(!this.massUpdate.checkPropertyType){
                delete request.property_type_id
            }

            if(!this.massUpdate.checkLocationType){
                delete request.location_type_id
            }

            if(!this.massUpdate.checkCategory){
                delete request.category_id
            }
            if(!this.massUpdate.checkLettable){
                delete request.lettable
            }

            this.$store.dispatch('PropertyController/massUpdate', request)
            .then(result => {
                this.open = false;
                this.loading = false;
                this.$alertNotification(this.$notificationV2('editing', 'location'));
                this.$refs.gofixTable.reloadTableKeepFilter();
            })
            .catch(error => {
                console.log(error);
                this.loading = false;
            })
        },
        async getTableData(callback){
            const { tableRequest , resolve,reject } = await callback();
            if(this.first_load){
                this.first_load = false;
                resolve();
                return;
            }

            tableRequest.property_id = this.propertyId;
            tableRequest.contract_id = this.$route.params.id;
            if(tableRequest.property_id && tableRequest.contract_id) {
                await this.$store.dispatch("PropertyController/getListLocations", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the locations", "danger");
                        reject();
                    })
            } else {
                resolve();
            }
        },
        exportCSV(){
            let params = {};
            params.contract_id = this.$route.params.id;
            params.property_id = this.propertyId
            if (params.property_id == 0) {
                return this.$alertNotification("Please select property", "danger");
            }
          let that = this;
          this.modals.export.open = true;
          this.modals.export.process = "Creating file csv";

          global.axios.get(`/api/contracts/${params.contract_id}/properties/${params.property_id}/location/export`, {
            params: params,
            responseType: 'blob',
            onDownloadProgress (progress) {
              that.modals.export.process = "Downloading";
            }
          })
              .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'PropertyLocationList.csv'); //or any other extension
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.modals.export.open = false
              })
              .catch(error => {
                this.modals.export.open = false
                console.log(error);
              });
        },
    }
}
</script>
